import Header from 'components/Common/Header/Header';
import OfferResponseBody from 'components/OfferComponents/OfferResponseComponents/OfferResponseBody/OfferResponseBody';
import React, { useEffect } from 'react';

const OfferResponse = () => {
  useEffect(() => {
    document.title = 'Offers';
  }, []);
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="offers" />

      {/* ---- body section ---- */}
      <OfferResponseBody />
    </main>
  );
};

export default OfferResponse;
